import { useRef, useEffect, useState } from "react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import TESTIMONIALS from "./constants";
import { ChevronLeft, ChevronRight, StarSharp } from "@mui/icons-material";
import Header from "../../../components/Header";

export default function Reviews() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [swiper, setSwiper] = useState(null);

  return (
    <Box
      mx="auto"
      mt={{ xs: 6, sm: 12 }}
      mb={{ xs: 4, md: 8 }}
      pt={10}
      pb={10}
      px={{ xs: 2, sm: 4 }}
      borderRadius={{ xs: 8, md: 16 }}
      boxSizing="border-box"
      position="relative"
    >
      <Header
        label="Reviews"
        title="See what people have to say about their experience"
      />

      {/* Custom Navigation Buttons */}

      <Box mt={{ xs: 4, md: 8 }} position="relative">
        <Swiper
          ref={swiperRef}
          modules={[Pagination, Scrollbar, A11y, Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          slidesPerGroup={1}
          loop={true}
          loopAdditionalSlides={2}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false, // Keeps autoplay even if user interacts
          }}
          breakpoints={{
            1200: { slidesPerView: 3, slidesPerGroup: 1 },
            900: { slidesPerView: 2, slidesPerGroup: 1 },
            0: { slidesPerView: 1, slidesPerGroup: 1 },
          }}
          onSwiper={setSwiper}
        >
          {TESTIMONIALS.map((elem, idx) => (
            <SwiperSlide key={idx}>
              <Stack
                bgcolor="#ffffff20"
                p={7}
                borderRadius={8}
                spacing={2}
                flex={1}
              >
                <Typography>{elem.body}</Typography>
                <Stack direction="row" alignItems="center" gap={2}>
                  <img
                    src={elem.avatar}
                    height={64}
                    width={64}
                    style={{ borderRadius: 100 }}
                    alt=""
                  />
                  <Stack>
                    <Typography>{elem.name}</Typography>
                    <Stack direction="row" spacing={0}>
                      {[1, 2, 3, 4, 5].map((_, index) => (
                        <StarSharp key={index} color="accent" fontSize="12" />
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Box
        mx="auto"
        width="fit-content"
        mt={6}
        // display={{ xs: "none", sm: "block" }}
      >
        <Stack direction="row" spacing={2}>
          <IconButton 
            ref={prevRef} 
            className="custom-prev"
            onClick={() => swiper?.slidePrev()}
          >
            <ChevronLeft />
          </IconButton>
          <IconButton 
            ref={nextRef} 
            className="custom-next"
            onClick={() => swiper?.slideNext()}
          >
            <ChevronRight />
          </IconButton>
        </Stack>
      </Box>
    </Box>
  );
}
